module.exports = __webpack_public_path__ + "media/images/up-ea0ad55ac3222b72c579663b88c1d3e6.png";